var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNavAccesos = function SvgNavAccesos(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "nav_accesos_svg__Capa_2",
    viewBox: "0 0 33.94 33.94"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "nav_accesos_svg__Capa_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m16.18 14.73 1.03-6.54M21.3 12.96l1.03-6.54M26.42 11.18l1.03-6.54",
    stroke: "#19d3c5",
    strokeWidth: "1.5px",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.69 33.25h32.56M3.7 33.25V3.39C3.7 1.89 4.89.68 6.36.68h3.3c2.75 0 4.99 2.27 4.99 5.08v3.19M14.65 33.25V16.04",
    fill: "none",
    stroke: "#b3b3b3",
    strokeLinecap: "round",
    strokeWidth: "1.37px"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 26.44,
    height: 5.84,
    x: 6.09,
    y: 7.64,
    rx: 2.78,
    ry: 2.78,
    transform: "rotate(-19.15 19.316 10.544)",
    fill: "none",
    stroke: "#b3b3b3",
    strokeLinecap: "round",
    strokeWidth: "1.37px"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.59,
    cy: 13.9,
    r: 2.91,
    fill: "none",
    stroke: "#b3b3b3",
    strokeLinecap: "round",
    strokeWidth: "1.37px"
  }))));
};
export default SvgNavAccesos;